import { Dialog } from '@angular/cdk/dialog';
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '@components/shared/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from '@components/shared/snackbar/snackbar.component';
import { appVersion, constantVariables } from '@shared/helper/configs';
import { CookieService } from '@shared/services/cookie.service';
import { GeneralService } from '@shared/services/general.service';
import { RouterService } from '@shared/services/router.service';
import { TokenService } from '@shared/services/token.service';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-root',
  providers: [RouterService],
  imports: [RouterOutlet, SnackbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent {
  private readonly generalService = inject(GeneralService);
  private readonly tokenService = inject(TokenService);
  private readonly userService = inject(UserService);
  private readonly cookieService = inject(CookieService);
  private readonly dialog = inject(Dialog);
  private readonly routerService = inject(RouterService);

  appVersion = appVersion;
  showContent = signal(false);
  fromApp = signal(false);

  ngOnInit() {
    this.handleVisitorId();
    this.userService.fetchWallet();
    this.handleShowDownloadApplicationDialog();
  }

  private handleVisitorId() {
    if (this.generalService.isBrowserOnly) {
      if (!localStorage.getItem(constantVariables.visitorId)) {
        this.tokenService.getVisitorId().subscribe({
          next: () => {
            this.showContent.set(true);
          },
          error: () => {
            this.showContent.set(true);
          },
        });
      } else {
        this.showContent.set(true);
      }
    } else {
      this.showContent.set(true);
    }
  }

  private handleShowDownloadApplicationDialog() {
    if (this.generalService.isBrowserOnly) {
      const currentUrl = new URL(window.location.href);
      const inAppParam = currentUrl.searchParams.get('inApp');
      if (inAppParam !== null) {
        const isInApp = inAppParam === 'true';
        this.fromApp.set(isInApp);
      }
    }
    if (this.fromApp()) {
      return;
    }
    if (this.cookieService.get('dialog-shown')) {
      return;
    }
    const data: ConfirmDialogData = {
      title: 'دانلود اپلیکیشن',
      message:
        'اپلیکیشن دیجی‌مامان اکنون برای دانلود در دسترس است. آیا مایل به دانلود اپلیکیشن هستید؟',
      okBtnText: 'دانلود',
      cancelBtnText: 'بی‌خیال',
    };
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      data,
    });
    dialog.closed.subscribe({
      next: (res) => {
        this.cookieService.set('dialog-shown', '1', 7);
        if (res === 'accept') {
          this.routerService.navigateTo('/settings/download');
        }
      },
    });
  }
}
